import React, { ReactNode } from 'react';
import styled from 'styled-components';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"styled-system"' has no exported member 'P... Remove this comment to see the full error message
import { Props as StyleProps } from 'styled-system';

import Box from 'components/Box';

import { colors } from '../theme';

const List = styled.ul`
  flex-wrap: wrap;
  list-style-type: none;
  padding-left: 0;
  color: ${colors.greyishBrown};
  li::before {
    content: '•';
    color: ${colors.waterBlue};
    display: inline-block;
    width: 1em;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const BulletList = ({
  items,
  columns = 1,
  itemMargin = 0,
  ...props
}: StyleProps & {
  items: Array<{
    key: string | number;
    value: ReactNode;
  }>;
  columns?: 1 | 2;
  itemMargin?: number;
  'data-qa-id'?: string;
}) => (
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box component={List} classes={['flex']} mb={`-${itemMargin}px`} {...props}>
    {items.map(
      ({ key, value }) =>
        value && (
          <Box
            component="li"
            key={key}
            width={[1, 1, 1, 1 / columns]}
            mb={`${itemMargin}px`}
          >
            {value}
          </Box>
        )
    )}
  </Box>
);

export default BulletList;
